// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__R55aj","error":"styles_error__4UnRa"};